import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"  viewBox="0 0 1080.000000 1080.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd"  transform="translate(0.000000,1080.000000) scale(0.100000,-0.100000)">

<path d="M4864 7085 c-9 -22 -1 -27 53 -32 109 -9 141 -29 199 -128 44 -74 67
-141 59 -173 -4 -15 -13 -83 -21 -152 -7 -69 -21 -179 -29 -245 -27 -203 -30
-298 -11 -314 20 -17 21 -14 35 114 6 55 17 156 26 225 8 69 19 158 24 198 5
40 11 75 13 78 9 8 25 -20 35 -61 6 -22 42 -132 81 -245 38 -113 100 -299 137
-415 38 -115 85 -259 105 -320 65 -194 107 -325 171 -525 115 -364 144 -445
160 -448 21 -4 29 20 124 333 15 50 35 115 45 145 10 30 28 89 40 130 12 41
36 118 52 170 17 52 37 118 45 145 8 28 21 68 28 90 7 22 27 85 44 140 31 103
87 284 166 543 25 81 52 167 59 192 62 204 59 197 68 165 5 -16 13 -73 19
-125 5 -52 14 -117 19 -145 5 -27 14 -95 20 -150 6 -55 17 -149 25 -210 7 -60
21 -164 29 -230 9 -66 22 -165 30 -220 8 -55 22 -149 31 -210 34 -238 113
-619 144 -690 5 -11 24 -56 42 -100 35 -85 42 -98 98 -185 46 -72 171 -196
243 -244 175 -114 435 -173 658 -147 85 9 103 16 101 37 -1 3 -58 7 -128 8
-134 3 -200 19 -308 78 -50 27 -145 103 -165 132 -8 11 -21 28 -29 36 -26 27
-105 153 -137 220 -29 60 -77 187 -103 270 -30 95 -85 379 -116 600 -8 58 -22
150 -30 205 -9 55 -23 152 -31 215 -25 194 -54 410 -94 695 -12 83 -25 182
-30 220 -28 218 6 280 163 294 57 5 72 10 75 24 3 16 -13 17 -236 17 l-239 0
-11 -37 c-33 -107 -96 -314 -108 -355 -8 -27 -20 -69 -28 -95 -8 -27 -33 -106
-55 -178 -23 -71 -56 -175 -72 -230 -17 -55 -51 -165 -76 -245 -101 -325 -105
-340 -155 -505 -11 -38 -24 -79 -28 -90 -4 -11 -18 -55 -31 -97 -12 -43 -25
-78 -29 -78 -3 0 -48 127 -99 283 -51 155 -97 291 -101 302 -5 11 -59 173
-121 360 -62 187 -131 396 -154 465 -24 69 -59 177 -80 240 -21 63 -50 149
-65 190 l-27 75 -257 3 c-225 2 -257 0 -262 -13z"/>
<path d="M4575 7068 c-2 -7 -17 -51 -33 -98 -17 -47 -58 -164 -92 -260 -33
-96 -68 -193 -77 -215 -29 -74 -42 -109 -83 -230 -70 -201 -191 -543 -208
-586 -9 -23 -17 -27 -77 -32 -37 -4 -81 -11 -99 -16 -185 -59 -225 -77 -319
-137 -175 -113 -294 -287 -347 -509 -41 -168 -21 -468 43 -631 73 -184 213
-343 367 -413 162 -74 363 -88 517 -36 140 48 273 156 347 284 91 156 120 348
75 490 -35 112 -120 231 -165 231 -20 0 -18 -6 16 -55 62 -91 74 -130 73 -250
-1 -82 -6 -125 -21 -171 -106 -320 -513 -467 -862 -311 -172 77 -304 248 -345
449 -32 153 -10 362 54 523 38 94 75 150 160 239 117 121 239 195 393 235 84
22 158 32 158 22 0 -3 -13 -40 -29 -81 -15 -41 -52 -145 -80 -230 -29 -85 -56
-164 -61 -175 -4 -11 -14 -38 -23 -60 -96 -251 -106 -270 -171 -314 -25 -17
-49 -31 -54 -31 -5 0 -15 -7 -22 -15 -11 -13 9 -15 169 -15 168 0 216 8 160
25 -11 4 -36 20 -55 37 -28 25 -34 37 -34 70 0 38 44 180 110 358 18 47 38
103 45 125 28 86 107 290 117 303 12 14 75 11 173 -9 342 -69 568 -260 701
-590 27 -68 38 -114 42 -165 5 -77 4 -79 -63 -128 -11 -8 -18 -17 -15 -19 3
-3 93 -6 200 -7 355 -3 470 0 470 10 0 5 -19 19 -42 31 -107 54 -159 121 -212
271 -19 51 -59 163 -89 248 -30 85 -65 182 -76 215 -11 33 -30 85 -41 115 -19
50 -130 360 -150 420 -5 14 -25 70 -45 125 -39 107 -141 394 -155 435 -7 22
-26 74 -111 310 -11 30 -32 89 -46 130 -30 87 -38 100 -65 100 -10 0 -20 -6
-23 -12z m-52 -748 c36 -96 69 -191 75 -210 6 -19 20 -60 32 -90 12 -30 27
-73 35 -95 7 -22 31 -89 53 -150 73 -201 162 -450 162 -453 0 -2 -32 26 -71
61 -167 155 -371 247 -587 264 -40 3 -75 9 -77 13 -2 4 10 45 26 91 17 46 53
147 81 224 54 152 85 239 147 414 23 63 41 117 41 120 0 24 28 -41 83 -189z"/>
</g>
</svg>

    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
